import React, {useEffect} from 'react'
import { useDispatch, useSelector} from "react-redux";
import {getAutoclaveCiclos, getAutoclaves} from "../../../actions/autoclaveActions";
import { getDadosPneus} from "../../../actions/tireActions";
import AutoclaveCicloMainView from "./AutoclaveCicloMainView";
import {CircularProgress} from "@material-ui/core";

const NA = 'N/A'

const AutoclaveCiclo = (props) => {


    const autoclaves = useSelector(state => state.autoclaves.Autoclaves);
    const pneus = useSelector(state => state.tires);
    const dispatch = useDispatch();


    useEffect(() => {
        dispatch(getAutoclaves());

        if (pneus.fabricantes.length === 0){
            dispatch(getDadosPneus());
        }
    }, []);


        if (autoclaves.length > 0) {

            return (
                <AutoclaveCicloMainView key={1}/>
            );
        } else {

            return( <CircularProgress/>);
        }
}

export default (AutoclaveCiclo);
